import "core-js/modules/web.dom-collections.iterator.js";
import { useState } from 'react';
const ids = new Map();

function generateId(key) {
  const count = ids.has(key) ? ids.get(key) + 1 : 0;
  ids.set(key, count);
  return `decibel-${key}-${count}`;
}

export function clearIds() {
  ids.clear();
}
export function useId(prefix) {
  if (process.env.NODE_ENV !== "production" && !prefix) {
    throw new Error('prefix is required');
  }

  const [id] = useState(() => generateId(prefix));
  return id;
}